import styled from "@emotion/styled";
import * as React from "react";

interface QuotesProps {
  indent?: boolean;
}

const QuoteContainer = styled.blockquote<{ indent: boolean }>(
  ({ indent, theme }) => ({
    margin: 0,
    paddingLeft: theme.spacing.LRG.sml,
    ...(indent
      ? {}
      : { borderLeft: `2px solid ${theme.colors.content.primary}` }),
  }),
);

const Quotes: React.FC<React.PropsWithChildren<QuotesProps>> = ({
  indent = false,
  children,
}): React.ReactElement => {
  return <QuoteContainer indent={indent}>{children}</QuoteContainer>;
};

export default Quotes;
